function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cf_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-12.4 32h640v480h-640z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#cf_svg__a)",
  transform: "translate(12.4 -32)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  d: "M-52 32h719.3v119H-52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff0",
  d: "M-52 391.6h719.3V512H-52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009a00",
  d: "M-52 271.3h719.3v120.3H-52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-52 151h719.3v120.3H-52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M247.7 32.5h119.9V512H247.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff0",
  d: "M99.3 137.7l-31.5-21.8-31.3 22L47.4 101 16.9 78l38.2-1 12.5-36.3L80.3 77l38.1.7L88.2 101"
}));

var SvgCf = function SvgCf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgCf;